import { render, staticRenderFns } from "./DocumentTemplatesModal.vue?vue&type=template&id=e00a33f0&scoped=true&"
import script from "./DocumentTemplatesModal.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplatesModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplatesModal.vue?vue&type=style&index=0&id=e00a33f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00a33f0",
  null
  
)

export default component.exports